import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "primarycare-binder";

export const store = configureStore({
  reducer,
});
